import { render, staticRenderFns } from "./PopularFabric.vue?vue&type=template&id=5c7d3b66"
import script from "./PopularFabric.vue?vue&type=script&lang=js"
export * from "./PopularFabric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports